import { useRef } from 'react';
import type { HTMLAttributes } from 'react';
import { useTruncationTooltip } from '../../hooks/use-truncation-tooltip';

/**
 * Wraps a hand-written `<table>` so its cells clip to one line and hovering a
 * clipped one reveals the full text.
 *
 * Drop-in for the `<div className="overflow-x-auto …">` these tables already
 * sit in: the behaviour is delegated from this container, so not one `<td>`
 * changes. `<DataTable>` does the same thing internally.
 *
 * A single cell opts out with `data-truncate="off"` — worth it for a cell that
 * genuinely needs two lines, or one holding a control rather than text.
 */
export function TruncatedTableContainer({
  children,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  const containerRef = useRef<HTMLDivElement>(null);
  const tooltip = useTruncationTooltip(containerRef);
  return (
    <div ref={containerRef} data-dt-truncate {...props}>
      {children}
      {tooltip}
    </div>
  );
}
